<template>
  <div>
    <ButtonBack class="mb_m"/>

    <input-name />
    <input-place />
    <input-date />
    <input-start />
    <input-finish />
    <input-close-time />
    <input-content />
  </div>
</template>

<script>
import ButtonBack from '@/components/ButtonBack'
import InputName from '@/components/EventClosed/InputName'
import InputPlace from '@/components/EventClosed/InputPlace'
import InputDate from '@/components/EventClosed/InputDate'
import InputStart from '@/components/EventClosed/InputStart'
import InputFinish from '@/components/EventClosed/InputFinish'
import InputCloseTime from '@/components/EventClosed/InputCloseTime'
import InputContent from '@/components/EventClosed/InputContent'

export default {
  components: {
    ButtonBack,
    InputName,
    InputPlace,
    InputDate,
    InputStart,
    InputFinish,
    InputCloseTime,
    InputContent
  }
}
</script>
